<template>
  <article>
    <section class="xbed-sub-title">
      <span>短租退款单列表</span>
    </section>
    <section class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>订单管理</BreadcrumbItem>
        <BreadcrumbItem>短租退款单列表</BreadcrumbItem>
      </Breadcrumb>
    </section>
    <section style="margin-top:20px">
      <Form :model="search" inline>
        <FormItem  label="创建日期：" prop="createDate" :label-width="84">
          <DatePicker v-model="defaultDate" format="yyyy-MM-dd" type="daterange" placeholder="选择日期" style="width: 220px"></DatePicker>
        </FormItem>
        <FormItem label="退款单号：" :label-width="105">
          <Input v-model="search.refundNo" placeholder="请输入订单号查询"></Input>
        </FormItem>
        <FormItem label="退款原因：" :label-width="110">
          <Select v-model="search.refundRea" transfer style="width:100px">
            <Option :value="-1">全部</Option>
            <Option :value="1">OMS操作</Option>
            <Option :value="2">人工建单</Option>
            <Option :value="3">用户操作</Option>
            <Option :value="4">系统退款</Option>
            <Option :value="5">OTA操作</Option>
          </Select>
        </FormItem>
        <FormItem label="退款状态：" :label-width="84">
          <Select v-model="search.refundStat" transfer style="width:100px">
            <Option :value="-1">全部</Option>
            <Option :value="1">待退款</Option>
            <Option :value="2">已退款</Option>
            <Option :value="3">已取消</Option>
            <Option :value="4">退款中</Option>
          </Select>
        </FormItem>
        <FormItem label="退款方式：" :label-width="84">
          <Select v-model="search.refundWay" transfer style="width:100px">
            <Option :value="-1">全部</Option>
            <Option :value="1">Xbed原路退款</Option>
            <Option :value="2">线下退款</Option>
            <Option :value="3">OTA退款</Option>
          </Select>
        </FormItem>
        <FormItem label="房间" v-model="search.room" :label-width="84">
          <Input v-model="search.room"></Input>
        </FormItem>
        <FormItem :label-width="84">
          <Button type="primary" @click="conditionSearch">查询</Button>
        </FormItem>
      </Form>
      <br>
      <Table stripe :columns="column" :data="refund.list"></Table>
      <div style="margin: 10px;overflow: hidden">
        <Page show-sizer placement="top" :total="refund.count" :current="refund.page" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
      </div>
    </section>
    <Modal ref="refundModal" :loading="true" v-model="refundModal.display" title="手动退款信息" @on-ok="subRefundInfo">
      <Form>
        <FormItem label="退款状态：" :label-width="100">
          <Input type="text" disabled :value="refundInfo.stat"></Input>
        </FormItem>
        <FormItem label="退款单金额：" :label-width="100">
          <Input type="text" disabled :value="refundInfo.refundAmout"></Input>
        </FormItem>
        <FormItem label="押金扣除" :label-width='100'>
          <Row v-if="(refundInfo.deductionArray&&refundInfo.deductionArray.length==0)">无</Row>
          <Row v-for="(item, index) in refundInfo.deductionArray" :key="index">
            <Col span="12">
              <Input disabled :value="item"></Input>
            </Col>
            <Col span="12">
              <Input disabled :value="refundInfo.deductionMoneyArray[index]"></Input>
            </Col>
          </Row>
        </FormItem>
        <FormItem label="实退金额：" :label-width="100">
          <Input type="text" v-model="refundInfo.activeMoney"></Input>
        </FormItem>
        <FormItem label="退款方式" :label-width="100">
          <Select v-model="refundInfo.refundChannel" transfer>
            <Option value="1">原路退回</Option>
            <Option value="2">线下退款</Option>
            <Option value="3">OTA退款</Option>
          </Select>
        </FormItem>
        <FormItem v-if="refundInfo.refundChannel==2" label="收款渠道" :label-width="100">
          <Select v-model="refundInfo.receiveSource" transfer>
            <Option value="微信">微信</Option>
            <Option value="支付宝">支付宝</Option>
            <Option value="银联">银联</Option>
            <Option value="线下">线下</Option>
          </Select>
        </FormItem>
        <FormItem v-if="((refundInfo.refundChannel==2)&&((refundInfo.receiveSource=='微信') || (refundInfo.receiveSource=='线下')))" label=" " :label-width="100">
          <Input type="text" :value="refundInfo.tip" disabled></Input>
        </FormItem>
        <FormItem v-if="((refundInfo.refundChannel==2)&&(refundInfo.receiveSource=='支付宝'))" label="账号" :label-width="100">
          <Input type="text" v-model="refundInfo.aliPay"></Input>
        </FormItem>
        <FormItem v-if="((refundInfo.refundChannel==2)&&(refundInfo.receiveSource=='银联'))" label="银行" :label-width="100">
          <Input type="text" v-model="refundInfo.bankName"></Input>
        </FormItem>
        <FormItem v-if="((refundInfo.refundChannel==2)&&(refundInfo.receiveSource=='银联'))" label="银行卡号" :label-width="100">
          <Input type="text" v-model="refundInfo.bankCount"></Input>
        </FormItem>
        <FormItem label="财务备注" :label-width="100">
          <Input v-model="refundInfo.omsRemark" type="textarea" :autosize="{minRows: 2,maxRows: 5}"></Input>
        </FormItem>
      </Form>
    </Modal>
    <Modal title="查看退款单" v-model="viewRefundModal.display" width="600">
      <Form>
        <FormItem label="退款状态" :label-width='80'>
          <Input disabled :value="viewRefundModal.data.stat"></Input>
        </FormItem>
        <FormItem label="退款金额" :label-width='80'>
          <Input disabled :value="viewRefundModal.data.refundAmout"></Input>
        </FormItem>
        <FormItem label="押金扣除" :label-width='80'>
          <Row v-if="(viewRefundModal.data.deductionArray&&viewRefundModal.data.deductionArray.length==0)">无</Row>
          <Row v-for="(item, index) in viewRefundModal.data.deductionArray" :key="index">
            <Col span="12">
              <Input disabled :value="item"></Input>
            </Col>
            <Col span="12">
              <Input disabled :value="viewRefundModal.data.deductionMoneyArray[index]"></Input>
            </Col>
          </Row>
        </FormItem>
        <FormItem label="实退金额" :label-width='80'>
          <Input disabled :value="viewRefundModal.data.activeMoney"></Input>
        </FormItem>
        <FormItem label="备注" :label-width='80'>
          <Input disabled type="textarea" :autosize="{minRows: 2,maxRows: 5}" :value="viewRefundModal.data.omsRemark"></Input>
        </FormItem>
      </Form>
    </Modal>
    <Modal ref="editInfoModal" :loading="true" title="编辑退款信息" v-model="editRefundModal.display" @on-ok="subEditInfo">
      <Form >
        <FormItem label="退款状态" :label-width='80'>
          <Input :value="refundInfo.stat" disabled></Input>
        </FormItem>
        <FormItem label="退款金额" :label-width='80'>
          <Input :value="refundInfo.refundAmout" disabled></Input>
        </FormItem>
        <FormItem label="押金扣除" :label-width='80'>
          <Row v-if="(refundInfo.deductionArray&&refundInfo.deductionArray.length==0)">
            <Col span="8">
              <Button type="primary" size="small" @click="addDeduct">新增</Button>
              <Button type="error" size="small" @click="delDeduct">删除</Button>
            </Col>
          </Row>
          <Row v-for="(item, index) in refundInfo.deductionArray" :key="index">
            <Col span="8" style="padding-right:15px">
              <Input v-model="refundInfo.deductionArray[index]" placeholder="输入扣款说明">
              </Input>
            </Col>
            <Col span="8" style="padding-right:15px">
              <InputNumber :min="0" :step="1" v-model="refundInfo.deductionMoneyArray[index]"
                :formatter="formatter" :parser="value => Math.abs(value)" @on-change="calcPrice(refundInfo)" placeholder="输入扣款金额">
              </InputNumber>
            </Col>
            <Col span="8" v-if="(index==refundInfo.deductionArray.length-1)">
              <Button type="primary" size="small" @click="addDeduct">新增</Button>
              <Button type="error" size="small" @click="delDeduct">删除</Button>
            </Col>
          </Row>
        </FormItem>
        <FormItem label="实退金额" :label-width='80'>
          <Input :value="refundInfo.activeMoney" disabled></Input>
        </FormItem>
        <FormItem label="图片上传" :label-width='80'>
          <template>
            <div class="upload-list" v-for="(item, index) in refundInfo.deductionImgArray" :key="index">
              <template v-if="item">
                  <img :src="item">
                  <div class="upload-list-cover">
                      <Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>
                  </div>
              </template>
            </div>
            <Upload
              ref="upload"
              :show-upload-list="false"
              :on-success="handleSuccess"
              :format="['jpg','jpeg','png']"
              :max-size="4096"
              :on-format-error="handleFormatError"
              :on-exceeded-size="handleMaxSize"
              :before-upload="handleBeforeUpload"
              :data="uploadData"
              multiple
              type="drag"
              action="//upload.qiniup.com"
              style="display: inline-block;width:58px;">
              <div style="width: 58px;height:58px;line-height: 58px;">
                  <Icon type="camera" size="20"></Icon>
              </div>
            </Upload>
          </template>
        </FormItem>
        <FormItem label="备注" :label-width='80'>
          <Input type="textarea" :autosize="{minRows: 2,maxRows: 5}" v-model="refundInfo.omsRemark"></Input>
        </FormItem>
      </Form>
    </Modal>
    <Modal title="查看照片" v-model="photoModal.display" width="900">
      <div class="upload-list photo-list" v-for="(item, index) in photoModal.imgList" :key="index">
        <template v-if="item">
            <img :src="item">
        </template>
      </div>
    </Modal>
  </article>
</template>

<script>
import Moment from "moment";
import Utils from "@/utils";
//import Config from "@/config";
import API from "@/api";
//import {STORE_KEY} from "../../constants";

export default {
  async created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.username = Utils.findFromLocalStorage("vue-username");
    this.env = Utils.findFromLocalStorage("env", "dev");
  },
  async mounted() {
    this.$Notice.config({
      top: 200
    });
    this.queryRefundsList();
  },
  data() {
    return {
      defaultDate: [Moment().subtract(7,'days').format('YYYY-MM-DD'), Moment().format('YYYY-MM-DD')],
      refundModal: {
        display: false,
        data: {},
      },
      photoModal: {
        display: false,
        imgList: []
      },
      defaultData: {
        id: '',
        sourceId: '',
        payType: "",
        stat: "",
        activeMoney: "",
        refundChannel: 1, 
        receiveSource: "微信", //
        aliPay: "",
        bankName: "",
        bankCount: "",
        remark: "",
        receiveAccount: "",
        refundAmout: "",
        tip: "如有需要，请在备注中记录收款信息",
        activeMoneyInt: 0,
        refundAmoutInt: 0,
        deductionArray: [],
        deductionImgArray: [],
        deductionMoneyArray: [],
      },
      viewRefundModal: {
        display: false,
        data: {}
      },
      editRefundModal: {
        display: false,
        data: {}
      },
      search: {
        "startDate": Moment().subtract(7,'days').format('YYYY-MM-DD'),
        "endDate": Moment().format('YYYY-MM-DD'),
        "page": 1,
        "size": 10,
        "orderNo": "",
        "refundStat": -1,
        "room": "",
        "refundRea": -1,
        "refundWay": -1,
        "refundNo": ""
      },
      refund: {
        list: [],
        count: 0,
        page: 1,
        pageSize: 10
      },
      column: [
        {
          title: "时间",
          key: "createdAt",
          align: "center",
          width: 200,
        },
        {
          title: "支付单号",
          key: "payNo",
          align: "center",
          width: 200
        },
        {
          title: "退款单号",
          key: "refundNo",
          width: 200,
          align: "center",
        },
        {
          title: "清洁单号",
          key: "cleanOrderNo",
          width: 200,
          align: "center"
        },
        {
          title: "房间",
          key: "roomName",
          width: 200,
          align: "center"
        },
        {
          title: "退款金额",
          key: "refundAmout",
          align: "center",
        },
        {
          title: "退款方式",
          key: "receiveSourceName",
          width: 200,
          align: "center",
        },
        {
          title: "收款账户",
          key: "receiveAccount",
          width: 200,
          align: "center",
          render: (h, params) => {
            if(params.row.receiveSourceName=="银联"){
              return h("div", [
                h('p',{
                  style: {
                    textAlign: "left"
                  }
                },`方式：${params.row.receiveSourceName}`),
                h('p',{
                  style: {
                    textAlign: "left"
                  }
                },`银行：${params.row.bankName}`),
                h('p',{
                  style: {
                    textAlign: "left"
                  }
                },`账号：${params.row.receiveAccount}`)
              ]);
            }else{
              return h("div", [
                h('p',{
                  style: {
                    textAlign: "left"
                  }
                },`方式：${params.row.receiveSourceName}`),
                h('p',{
                  style: {
                    textAlign: "left"
                  }
                },`账号：${params.row.receiveAccount}`)
              ]);
            }
          }
        },
        {
          title: "实退金额",
          key: "activeMoney",
          align: "center",
        },
        {
          title: "退款状态",
          key: "stat",
          align: "center"
        },
        {
          title: "照片",
          align: "center",
          render: (h, param) => {
            if(param.row.deductionImgArray.length>0){
              return h('Button',{
                on: {
                  click: () =>{
                    this.photoModal.display = true;
                    this.photoModal.imgList = param.row.deductionImgArray
                  }
                }
              },'查看')
            }else{
              return h('div', {}, '--')
            }
          }
        },
        {
          title: "备注",
          key: "updatedAt",
          width: 200,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h('p', {
                style: {
                  textAlign: "left"
                }
              }, params.row.remark)
            ]);
          }
        },
        {
          title: "操作",
          align: "center",
          render: (h, params) => {
            if(params.row.stat=="已退款"){
              return h('div', [
                h('Button', {
                  props: {
                    type: "info",
                    size: "small"
                  },
                  style: {
                    marginLeft: "10px"
                  },
                  on: {
                    click: () => {
                      this.viewRefundModal.data = params.row;
                      this.viewRefundModal.display = true;
                      this.calcPrice( params.row)
                    }
                  }
                }, '查看'),
              ])
            }
            // 覃威说隐藏 2018-07-02
            // else{
            //   return h('div', [
            //     h('Button', {
            //       props: {
            //         type: "warning",
            //         size: "small"
            //       },
            //       on: {
            //         click: () => {
            //           this.refundInfo = this.copyData(params.row, this.refundInfo);
            //           this.refundInfo.deductionMoneyArray=this.refundInfo.deductionMoneyArray.map((val)=>{
            //             return Number(val);
            //           });
            //           if(this.refundInfo.deductionArray.length==0){
            //             this.refundInfo.deductionArray = [""];
            //             this.refundInfo.deductionMoneyArray = [0];
            //           }
            //           this.refundInfo.omsRemark = '';
            //           this.calcPrice(this.refundInfo);
            //           this.editRefundModal.display = true;
            //         }
            //       }
            //     }, '编辑'),
            //     h('Button', {
            //       props: {
            //         type: "error",
            //         size: "small"
            //       },
            //       on: {
            //         click: () => {
            //           this.refundInfo = this.copyData(params.row, this.refundInfo);
            //           this.calcPrice(this.refundInfo);
            //           !this.refundInfo.refundChannel&&(this.refundInfo.refundChannel = 1), 
            //           this.refundInfo.receiveSource = "微信",
            //           this.refundInfo.tip = "如有需要，请在备注中记录收款信息",
            //           this.refundModal.display = true;
            //         }
            //       },
            //       style: {
            //         marginLeft: "10px"
            //       },
            //     }, '手动退款')
            //   ])
            // }
          }
        }
      ],
      validateStatus: false,
      imgName: '',
      visible: false,
      uploadData: {},
      refundInfo: {
        id: '',
        sourceId: '',
        payType: "",
        stat: "",
        activeMoney: "",
        refundChannel: "1", //
        receiveSource: "微信", //
        aliPay: "",
        bankName: "",
        bankCount: "",
        omsRemark: "",
        remark: "",
        receiveAccount: "",
        refundAmout: "",
        tip: "如有需要，请在备注中记录收款信息",
        activeMoneyInt: 0,
        refundAmoutInt: 0,
        deductionArray: [],
        deductionImgArray: [],
        deductionMoneyArray: [],
      },
    }
  },
  methods: {
    changePage(pageIndex) {
      this.search.page = pageIndex;
      this.queryRefundsList();
    },
    changePageSize(pageSize) {
      this.search.page = 1;
      this.search.size = pageSize;
      this.queryRefundsList();
    },
    addDeduct() {  // 增加扣款项
      if(this.refundInfo.deductionArray.length>=20){
        this.$Notice.error({
          title: '数量超过限制'
        });
        return
      }
      this.refundInfo.deductionArray.push('');
      this.refundInfo.deductionMoneyArray.push(0);
    },
    delDeduct() {  // 删除扣款项
      this.refundInfo.deductionArray.pop();
      this.refundInfo.deductionMoneyArray.pop();
      this.calcPrice(this.refundInfo);
    },
    formatter(value) {
      return (value==0?0:`-${value}`)
    },
    calcPrice(obj) {  // 计算实际扣款金额
      let total = 0;
      let arr = obj.deductionMoneyArray;
      for(let i=0; i<arr.length; i++){
        total += Math.abs(arr[i])
      }
      if(total>obj.refundAmout){
        this.$Notice.error({
          title: "扣除金额超过退款金额"
        })
        return false;
      }
      obj.activeMoney = (obj.refundAmout-total).toFixed(2);
      return true;
    },
    async conditionSearch() {  // 条件查询
      this.search.startDate = Moment(this.defaultDate[0]).format("YYYY-MM-DD");
      this.search.endDate = Moment(this.defaultDate[1]).format("YYYY-MM-DD");
      this.queryRefundsList();
    },
    async subEditInfo() { // 提交编辑退款信息
      if(!this.calcPrice(this.refundInfo)){
        this.$refs.editInfoModal.buttonLoading = false;
        return
      }
      let arr = this.refundInfo.deductionMoneyArray;
      let param = {
        "deductionImgList": this.refundInfo.deductionImgArray.join(","),
        "deductionList": this.refundInfo.deductionArray.join(","),
        "deductionMoneyList": arr.map(val => val*100).join(','),
        "id": this.refundInfo.id,
        "operator": this.username,
        "omsRemark": this.refundInfo.omsRemark
      }
      if(param.omsRemark.trim().length==0){
        this.$Notice.error({
          title: '备注不能为空'
        });
        this.$refs.editInfoModal.buttonLoading = false;
        return;
      }
      let resp = await this.requestJson(param,"subRefundInfo");
      if(resp.retCode){
        this.$Notice.error({
          title: '编辑信息提交失败',
          desc: resp.msg
        });
        this.$refs.editInfoModal.buttonLoading = false;
        return
      }
      this.$Notice.success({
        title: '编辑成功'
      });
      this.$refs.editInfoModal.buttonLoading = false;
      this.editRefundModal.display = false;
      this.queryRefundsList();
    },
    //手动退款
    async subRefundInfo() {
      let params = JSON.parse(JSON.stringify(this.refundInfo));
      this.$refs.refundModal.buttonLoading = false;
      params.activeMoneyInt = parseInt(params.activeMoney*100);
      params.refundAmoutInt = parseInt(params.refundAmout*100);
      if(params.refundChannel!="2"){
        params.receiveSource = "";
        params.aliPay = "";
        params.bankName = "";
        params.bankCount = "";
        params.bankName = "";
        params.receiveAccount = '';
      }else{
        switch (params.receiveSource) {
          case "微信":
            break;
          case '支付宝':
            if (params.aliPay === '') { 
              this.$Notice.error({
                title: '请输入支付宝账号'
              });
              return; 
            }
            if (/.*[\u4e00-\u9fa5]+.*$/.test(params.aliPay)) { 
              this.$Notice.error({
                title: '支付宝账号不正确'
              });
              return; 
            }
            if (params.aliPay.length > 60) { 
              this.$Notice.error({
                title: '支付宝账号超出长度'
              });
              return; 
            }
            params.receiveAccount = params.aliPay;
            break;
          case '银联':
            if (params.bankName === '') { 
              this.$Notice.error({
                title: '请输入银行名称'
              });
              return; 
            }
            if (params.bankCount === '') { 
              this.$Notice.error({
                title: '请输入银行卡号'
              });
              return; 
            }
            if (!/^\d{16,21}$/.test(params.bankCount)) { 
              this.$Notice.error({
                title: '银行卡号不正确，16-21位'
              });
              return; 
            }
            if (params.bankName.length > 60) { 
              this.$Notice.error({
                title: '银行名称超出长度'
              });
              return; 
            }
            if (params.bankCount.length > 60) { 
              this.$Notice.error({
                title: '银行卡号超出长度'
              });
              return; 
            }
            params.receiveAccount = params.bankCount;
            break;
          case '线下':
            break;
        }
      }
      if (params.omsRemark.trim() == '') { 
        this.$Notice.error({
          title: '请填写备注'
        });
        return;
      }
      if (params.omsRemark.length > 250) { 
        this.$Notice.error({
          title: '备注长度不能超过250个字符'
        });
        return;
      }
      //调用手动退款接口
      let resp = await this.requestJson({
        activeMoney: params.activeMoneyInt,
        bankName: params.bankName,
        id: params.id,
        receiveAccount: params.receiveAccount,
        receiveSource: params.receiveSource,
        refundChannel: params.refundChannel,
        omsRemark: params.omsRemark,
        sourceId: params.sourceId,
        userName: this.username
      },'refundByHand')
      if (resp.retCode) {
        this.$Notice.error({
          title: "手动退款失败",
          desc: resp.msg
        });
        return;
      }
      this.$Notice.success({
        title: "退款成功"
      });
      this.refundModal.display = false;
      this.queryRefundsList();
    },
    validateForm(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.validateStatus = true;
        } else {
          this.validateStatus = false;
        }
      })
    },
    async queryRefundsList() {
      let param = {
        "startDate": this.search.startDate,
        "endDate": this.search.endDate,
        "page": this.search.page,
        "size": this.search.size,
        "orderNo": this.search.orderNo,
        "refundStat": (this.search.refundStat=="-1"?"":this.search.refundStat),
        "room": this.search.room,
        "refundRea": (this.search.refundRea=="-1"?"":this.search.refundRea),
        "refundWay": (this.search.refundWay=="-1"?"":this.search.refundWay),
        "refundNo": this.search.refundNo
      }
      let resp = await this.requestJson(param,"queryShortRentList")
      if(resp.retCode){
        this.$Notice.error({
          title: '查询列表失败'
        });
        return
      }
      this.refund.list = resp.result;
      this.refund.count = resp.count;
      this.refund.page = resp.page;
      this.refund.pageSize = resp.pageSize;
    },
    async requestJson(params,apiName) {
      return (await API.omsAPI[this.env].order[apiName](
        params,
        this.token
      )).data;
    },
    handleRemove (file) {
      let list = this.refundInfo.deductionImgArray;
      list.splice(list.indexOf(file),1);
    },
    handleSuccess (res) {
      if(this.refundInfo.deductionImgArray.length >= 20){
        this.refundInfo.deductionImgArray = this.refundInfo.deductionImgArray.slice(0,20);
      }else{
        this.refundInfo.deductionImgArray.push(res.materialBase.url);
      }
    },
    handleFormatError (file) {
      this.$Notice.warning({
        title: 'The file format is incorrect',
        desc: 'File format of ' + file.name + ' is incorrect, please select jpg or png.'
      });
    },
    handleMaxSize (file) {
      this.$Notice.warning({
        title: 'Exceeding file size limit',
        desc: 'File  ' + file.name + ' is too large, no more than 2M.'
      });
    },
    async handleBeforeUpload () {
      if (this.refundInfo.deductionImgArray.length >= 20) {
        this.$Notice.warning({
          title: '上传图片数量超过限制.'
        });
        return false;
      }else{
        let token = (await API.omsAPI[this.env].common.getUploadToken(false, this.token)).data;
        this.uploadData.token = token;
        return true;
      }
    },
    copyData(source,target) {
      let json = JSON.stringify(source);
      let obj = JSON.parse(json);
      Object.keys(target).forEach(key => {
         obj[key]&&(target[key] = obj[key]);
         obj[key]=="-"&&(target[key] = "")
      });
      return target;
    }
  }
}

</script>

<style>
  .upload-list{
    display: inline-block;
    width: 60px;
    height: 60px;
    text-align: center;
    line-height: 60px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0,0,0,.2);
    margin-right: 4px;
  }
  .photo-list{
    width: auto;
    height: auto;
  }
  .upload-list img{
    width: 100%;
    height: 100%;
  }
  .upload-list-cover{
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
      background: rgba(0,0,0,.6);
  }
  .upload-list:hover .upload-list-cover{
    display: block;
  }
  .upload-list-cover i{
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
  }
</style>


// WEBPACK FOOTER //
// src/pages/order/short-rent-list.vue